<div class="">
    <label class="font-semibold block mb-2">{{ label() }}</label>
    <p-date-picker [id]="id()" [formControl]="$any(control())" class="w-full" [showIcon]="true" [appendTo]="'body'" [invalid]="!!(control()?.invalid && (control()?.dirty || control()?.touched))" dateFormat="dd/mm/yy" fluid> </p-date-picker>
</div>
